import { useMessageStore } from "@/state/stores";
import { useShallow } from "zustand/react/shallow";

/**
 * Hook that returns the IDs of messages that can be cancelled
 * @returns Array of message IDs that are currently processing and can be cancelled
 */
export function useCancellableMessages() {
  const cancellableMessageIds = useMessageStore(
    useShallow((state) => {
      return state.messages
        .filter(
          (message) =>
            message.status === "pending" || message.status === "processing",
        )
        .map((message) => message.id);
    }),
  );

  return cancellableMessageIds;
}
